<app-accordion>
<app-accordion-item
  id="SkuInventory"
  icon="box"
  label="Simulação"
  bodyClass="rounded border border-neutral-300 dark:border-neutral-700 p-3"
>
  <div class="flex flex-col gap-3">
    <div>
      <label class="block text-sm font-medium mb-1">Contas</label>
      <ng-select
        [items]="franchises"
        bindLabel="label"
        bindValue="name"
        [hideSelected]="true"
        [closeOnSelect]="false"
        [clearable]="true"
        [searchable]="true"
        [multiple]="true"
        [(ngModel)]="simulationAccounts"
        [placeholder]="'Selecione as contas'"
        [loading]="loadingAccounts"
        [searchFn]="customSearchFn"
        aria-label="Selecionar contas para simulação"
        class="w-full control-height"
      >
        <ng-template ng-label-tmp let-item="item" let-clear="clear">
          {{ item.name?.toUpperCase() }}
          <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <div class="flex flex-col">
            <span class="font-medium">{{ item.name }}</span>
            <span class="text-xs text-neutral-500">{{ item.description }}</span>
          </div>
        </ng-template>
      </ng-select>
    </div>

    <div>
      <label class="block text-sm font-medium mb-1">Política comercial</label>
      <ng-select
        [items]="tradePolicies"
        bindLabel="name"
        bindValue="id"
        [hideSelected]="true"
        [closeOnSelect]="false"
        [clearable]="true"
        [searchable]="true"
        [multiple]="false"
        [(ngModel)]="simulationSalesChannel"
        [placeholder]="'Selecione uma política comercial'"
        aria-label="Selecionar política comercial"
        class="w-full control-height"
      >
        <ng-template ng-label-tmp let-item="item" let-clear="clear">
          {{ item.name?.toUpperCase() }}
          <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
        </ng-template>
      </ng-select>
    </div>
    <div>
      <label class="block text-sm font-medium mb-1">Código postal</label>
      <input
        name="simulationPostalCode"
        type="text"
        aria-label="CEP para simulação"
        class="w-full control-height px-3 border rounded-md bg-white text-black dark:bg-neutral-900 dark:text-white"
        [(ngModel)]="postalCode"
      />
    </div>

    <div>
      <app-button
        color="primary"
        [fullWidth]="true"
        (buttonClick)="simulate()"
        icon="shopping-cart"
        aria-label="Executar simulação de frete"
        >Simular</app-button
      >
    </div>
  </div>

  @if (loading) {
  <div class="my-2" aria-label="Carregando simulação"><app-loading /></div>
  } @if (!!error) {
  <app-alert [type]="'danger'" aria-label="Erro na simulação">{{ error }}</app-alert>
  } @if (result.size > 0 && !loading) {
  <app-accordion class="mt-4" aria-label="Resultados da simulação">
    @for (account of sortedResults; track account.key) {
    <app-accordion-item
      [id]="`AccordionItemSku${skuId}Warehouse${account.key}`"
      [label]="`${getSimulationLabel(account.key, account.value)}`"
      [headerClass]="hasDeliveryAvailable(account.value) ? 'bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300' : 'bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-300'"
    >
      @if (!account.value.errorMessage) { @if (account.value.genericReasons?.length) {
      @for (reason of account.value.genericReasons; track reason) {
      <app-alert icon="alert-triangle" type="danger" [attr.aria-label]="'Razão genérica para ' + account.key">
        <h2 class="block text-sm font-medium mb-1">
          {{ getSimulationGenericMessage(account.key, reason.Key ?? 1, skuId.toString()).title }}
        </h2>
        <p class="text-xs">
          {{
            getSimulationGenericMessage(account.key, reason.Key ?? 1, skuId.toString()).message
          }}
        </p>
        <a
          class="text-xs"
          target="_blank"
          [attr.aria-label]="'Abrir SKU ' + skuId + ' na conta ' + account.key"
          [href]="
            getSimulationGenericMessage(account.key, reason.Key ?? 1, skuId.toString()).link
          "
          >{{ skuId }}</a
        >
      </app-alert>
      } } @else {
      <div
        class="rounded border border-neutral-200 dark:border-neutral-700 p-3 bg-white dark:bg-neutral-900"
        [attr.aria-label]="'Detalhes de entrega para ' + account.key"
      >
        <div class="flex flex-col flex-wrap justify-between gap-2">
          @for (responseFreight of account.value.freightSimulated; track responseFreight) { @for
          (slaSimulated of responseFreight.slaResponseFreightSimulated; track slaSimulated) {
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm" [attr.aria-label]="'SLA ' + slaSimulated.slaTypeName + ' - Doca ' + slaSimulated.dockId">
            <div aria-label="Dock ID">
              <div>Dock ID</div>
              <div class="font-medium">{{ slaSimulated.dockId }}</div>
            </div>
            <div aria-label="Nome da doca">
              <div>Nome da doca</div>
              <div class="font-medium">{{ slaSimulated.dockName }}</div>
            </div>
            <div aria-label="Warehouse ID">
              <div>Warehouse ID</div>
              <div class="font-medium">{{ slaSimulated.wareHouseId }}</div>
            </div>
            <div aria-label="Nome do Warehouse">
              <div>Nome do Warehouse</div>
              <div class="font-medium">{{ slaSimulated.wareHouseName }}</div>
            </div>
            <div aria-label="Código postal">
              <div>Código postal</div>
              <div class="font-medium">
                {{ slaSimulated.zipCodeStart }} até {{ slaSimulated.zipCodeEnd }}
              </div>
            </div>
            <div aria-label="Tipo de SLA">
              <div>Tipo de SLA</div>
              <div class="font-medium">{{ slaSimulated.slaType }}</div>
            </div>
            <div aria-label="Nome do SLA">
              <div>Nome do SLA</div>
              <div class="font-medium">{{ slaSimulated.slaTypeName }}</div>
            </div>
            <div aria-label="Freight table ID">
              <div>Freight table ID</div>
              <div class="font-medium">{{ slaSimulated.freightTableId }}</div>
            </div>
            <div aria-label="Freight table name">
              <div>Freight table name</div>
              <div class="font-medium">{{ slaSimulated.freightTableName }}</div>
            </div>
            <div aria-label="Preço de listagem">
              <div>Preço de listagem</div>
              <div class="font-medium">{{ slaSimulated.listPrice }}</div>
            </div>
            <div aria-label="Preço absoluto">
              <div>Preço absoluto</div>
              <div class="font-medium">{{ slaSimulated.absoluteMoneyCost }}</div>
            </div>
            <div aria-label="Tempo de trânsito">
              <div>Tempo de trânsito</div>
              <div class="font-medium">{{ slaSimulated.transitTime }}</div>
            </div>
            <div aria-label="Tempo de doca">
              <div>Tempo de doca</div>
              <div class="font-medium">{{ slaSimulated.dockTime }}</div>
            </div>
            <div aria-label="Data estimada">
              <div>Data estimada</div>
              <div class="font-medium">{{ slaSimulated.estimateDate }}</div>
            </div>
          </div>
          <hr class="my-3" />
          } }

          <pre [innerHTML]="account.value.debug"></pre>
        </div>
      </div>
      } } @else {
      <p aria-label="Erro de simulação no seller">Houve um erro ao executar a simulação nesse seller.</p>
      }
    </app-accordion-item>
    }
  </app-accordion>
  }
</app-accordion-item>
</app-accordion>
